module.exports = __webpack_public_path__ + "img/logo-up-5.352633d6.png";